import { InputLabel, MenuItem } from '@mui/material';
import { memo } from 'react';
import { ItemVM } from 'shell/view-models/item';
import { PmiSelect } from 'shell/components/shared/pmi-select';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';
import { SelectChangeEvent } from '@mui/material';

interface InitiativeAireListProps {
  value: string;
  required?: boolean;
  disabled?: boolean;
  onChange: (event: SelectChangeEvent<string>) => void;
  errors?: boolean;
}

const typeInitiative = Object.freeze([
  {
    id: '3',
    value: 'Comunicazione Ufficiale dello Stato Civile',
  },
  {
    id: '4',
    value: 'Comunicazione Ufficio Consolare ',
  },
]);

const InitiativeAireListComponent = ({
  onChange,
  disabled,
  required,
  value,
  errors,
}: InitiativeAireListProps): React.ReactElement => {
  return (
    <PmiFormControl fullWidth>
      <InputLabel error={errors} id="type-initiative-label">
        {required ? 'Iniziativa *' : 'Iniziativa'}
      </InputLabel>
      <PmiSelect
        labelId="type-initiative-label"
        id="typeInitiative"
        name="typeInitiative"
        value={value}
        label={required ? 'Inizativa *' : 'Inizativa'}
        onChange={onChange}
        disabled={disabled}
        error={errors}
      >
        {typeInitiative
          ? typeInitiative.map((element: ItemVM) => (
              <MenuItem key={element.id} value={element.id}>
                {element.value}
              </MenuItem>
            ))
          : []}
      </PmiSelect>
    </PmiFormControl>
  );
};

InitiativeAireListComponent.displayName = 'initiative aire list component';

const InitiativeAireList = memo(InitiativeAireListComponent);

export default InitiativeAireList as typeof InitiativeAireListComponent;
